import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {finalize} from 'rxjs';
import { LoaderService } from './loader.service';
import {Logger} from '@shared/utils/logger';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  loaderService.show();

  Logger.log('LOAD DATA START', req.url)

  return next(req).pipe(
    finalize(() => loaderService.hide()),
  );
};
